class PagesSingleNews{

	constructor() {

		if( ! document.body.classList.contains('single-news') ){
			return;
		}

		let navigation = document.querySelectorAll('.single-news-section-nav');
		navigation.forEach( (item, i) => {
			item.addEventListener("click", (e) => {
				let index = item.dataset.section;
				let section = document.querySelector(`.single-news-section[data-section="${index}"]`);
				if(section){
					smoother.scrollTo(section, true, "top 100px");
				}
			});
		});

		let mm = gsap.matchMedia();
		mm.add("(min-width: 992px)", () => {

			let logo = document.querySelector('.header-logo');
			let pos = logo.getBoundingClientRect();
			ScrollTrigger.create({
				trigger: '.single-news-nav',
				pin: true,
				start: "top-="+pos.top+" top",
				endTrigger: '.single-news-container',
				end: "bottom bottom"
			});

		});

	}

}